// extracted by mini-css-extract-plugin
export default {"wrapper":"Fp-z","response":"Gp-z","error":"Hp-z","disabled":"Ip-z","buttons":"Jp-z","feedbackQuestionSection":"Kp-z","yesNoWrapper":"Lp-z"};